var render, staticRenderFns
import script from "./NewsletterForm.js?vue&type=script&lang=js&"
export * from "./NewsletterForm.js?vue&type=script&lang=js&"
import style0 from "./NewsletterForm.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports